import axios from '@/lib/axios';
import type { EnergyConsumptionResponse, EnergyDevice, EnergyHistoryResponse } from '@/types/energy';

export const getEnergyDevices = async (): Promise<EnergyDevice[]> => {
  const req = await axios.get('/energy/');
  return req.data.results;
};

export const getEnergyHistory = async ({
  deviceId,
  startDate,
  endDate,
}: {
  deviceId: string;
  startDate: string;
  endDate: string;
}): Promise<EnergyHistoryResponse> => {
  const params = new URLSearchParams({ startDate, endDate });
  const req = await axios.get(`/energy/${deviceId}/energy?${params.toString()}`);
  return req.data;
};

export const getEnergyConsumption = async ({
  deviceId,
  startDate,
  endDate,
}: {
  deviceId: string;
  startDate: string;
  endDate: string;
}): Promise<EnergyConsumptionResponse> => {
  const params = new URLSearchParams({ startDate, endDate });
  const req = await axios.get(`/energy/${deviceId}/consumption?${params.toString()}`);
  return req.data;
};
